import { CAST_AI } from '@cast/constants';

import { globalTourSteps } from 'constants/tour';

export const securityActionButtonStep = {
  [globalTourSteps.connectMyCluster]: {
    text: 'Start securing your cluster now! Connect it and get a free configuration scanning report.',
  },
  [globalTourSteps.enableSecurity]: {
    text: `Start securing your cluster now! Enable ${CAST_AI} Security to protect your infrastructure and get comprehensive security insights.`,
  },
};
